import request from '@/config/axios'

export const login = async (data) => {
  return await request.post({ url: '/system/auth/login', data })
}

export const loginOut = async () => {
  return await request.post({ url: '/system/auth/logout' })
}

export const getInfo = async (): Promise<UserInfoVO> => {
  return await request.get({ url: '/system/auth/get-permission-info' })
}

export const getTenantIdByName = async (name: string) => {
  return await request.get({ url: '/system/tenant/get-id-by-name', params: { name } })
}
